import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const optionsWrapper = {
  width: '300px',
  border: '2px solid white',
  borderRadius: '8px',
  textAlign: 'left',
}

const option = {
  padding: '10px',
}

const optionHeader = {
  color: colors.n5.base,
  textTransform: 'uppercase',
  fontSize: fontSizes.caps.medium,
  fontWeight: fontWeights.bold,
  paddingBottom: '7px',
}

// The kuiper CheckBox label is white for dark backdrops; this popover is white.
const overrideToggle = {
  paddingBottom: '7px',
  '.kuiper-checkbox.kuiper-input label': {
    color: colors.n5.base,
  },
}

const optionInput = {
  '.kuiper-input-container': {
    border: `1px solid ${colors.n9.base}`,
    borderRadius: '3px !important',
  },
  '.kuiper-input-textarea .kuiper-input-element': {
    lineHeight: '15px',
    height: '50px !important',
  },
  '.kuiper-input-textarea .kuiper-input-container': {
    height: '50px',
  },
  '.kuiper-input-textarea.kuiper-theme-caption textarea': {
    padding: '6px 7px',
  },
}

const fileUploadStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontFamily: fonts.sourceCode,
  fontSize: fontSizes.xxSmall,
  fontWeight: fontWeights.bold,
  color: colors.n5.base,
  '.kuiper-icon-wrapper': {
    color: colors.n6.base,
    '&:hover': {
      color: colors.n5.base,
    },
    '&:active': {
      color: colors.n4.base,
    },
  },
  'div.kuiper-cover-asset-upload-buttons': {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 5px',
    width: '71px',
    '.kuiper-asset-options-cover-asset-upload>input': {
      display: 'none',
    },
  },
}

const header = {
  borderBottom: `2px solid ${colors.n9.base}`,
  padding: '16px 10px 18px 10px',
  fontSize: fontSizes.caps.large,
  color: colors.n3.base,
  textTransform: 'uppercase',
  fontWeight: fontWeights.bold,
  textAlign: 'left',
}

const footer = {
  marginTop: '24px',
  backgroundColor: colors.n10.base,
  padding: '6px 10px',
  display: 'flex',
  justifyContent: 'flex-end',
}

const styles = {
  optionsWrapper,
  option,
  optionHeader,
  optionInput,
  overrideToggle,
  fileUploadStyle,
  header,
  footer,
}

export { styles }
